import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { initWebAnalytics } from './lib/analytics'
import { readStoredTheme } from './hooks/useTheme'
import './styles/theme.css'
import './styles/global.css'

// Apply persisted theme before React mounts so the first paint is in the
// right palette (no white flash on dusk-preferring devices).  readStoredTheme
// swallows Safari Private Browsing exceptions internally.
;(function applyInitialTheme() {
  const stored = readStoredTheme()
  if (stored) {
    document.documentElement.dataset.theme = stored
    return
  }
  const prefersDark =
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-color-scheme: dark)').matches
  document.documentElement.dataset.theme = prefersDark ? 'dusk' : 'daylight'
})()

// Initialize PostHog before the first render so the initial $pageview (fired by
// usePageviewTracking inside <App>) and any early autocaptured clicks are sent.
initWebAnalytics()

const container = document.getElementById('root')
if (!container) throw new Error('Root container not found')

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
)
